import { Button, Grid } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import {
  RHFAutocomplete,
  RHFCheckbox,
  RHFDateTimePicker,
  RHFTextField,
} from "../../RHFComponents/RHFComponents";
import {
  doctor,
  specialities,
  performance,
  spuntaTerapie,
} from "../../../networking";
import {
  CheckedServicesContext,
  FormCheckedServices,
} from "../Context/CheckedServicesContextWrapper";

const MainForm = () => {
  const context = useContext(CheckedServicesContext);

  const [dottoriMEDICIPRE, setDottoriMEDICIPRE] = useState<any>([]);
  const [specialitiesSPECIALITA, setSpecialitiesSPECIALITA] = useState<any>([]);
  const [performancePRESTAZIONI, setPerformacePRESTAZIONI] = useState<any>([]);

  const [dataTerapie, setDataTerapie] = useState<any>([]);

  // lista controllers per interrompere api
  let doctorsController: AbortController | null = null;
  let performancesController: AbortController | null = null;
  let specialitiesController: AbortController | null = null;

  // elenco degli watcher
  const watchSpecialita: any =
    context?.methodsFormCheckedServices.watch(`specialita`);
  const watchPrestazione: any =
    context?.methodsFormCheckedServices.watch(`prestazione`);
  const watchMedico: any = context?.methodsFormCheckedServices.watch(`medico`);
  const watchDataDa: any =
    context?.methodsFormCheckedServices.watch(`dallaData`);
  const watchDataA: any = context?.methodsFormCheckedServices.watch(`allaData`);

  async function requestSpecialitiesListSPECIALITA() {
    if (specialitiesController) {
      specialitiesController.abort();
    }
    specialitiesController = new AbortController();

    try {
      const data = await specialities(
        {
          tipoAgenda: "",
          listino: "",
          specialita: "",
          prestazione: watchPrestazione?.PRESTAZIONE ?? "",
          medico: [watchMedico?.CODICE],
        },
        specialitiesController.signal
      );
      const specialitiesList = data.data.dati;
      console.log({ specialitiesList });
      setSpecialitiesSPECIALITA(specialitiesList);
    } catch (error) {
      console.error("Error fetching specialita:", error);
    }
  }

  async function requestPerformancePRESTAZIONI() {
    if (performancesController) {
      performancesController.abort();
    }
    performancesController = new AbortController();

    try {
      const data = await performance(
        {
          tipoAgenda: "",
          listino: "",
          specialita: watchSpecialita?.SPECIALITA ?? "",
          prestazione: "",
          medico: [watchMedico?.CODICE],
        },
        performancesController.signal
      );
      const performancesList = data.data.dati;
      console.log({ performancesList });
      setPerformacePRESTAZIONI(
        performancesList.filter(
          (item: any, index: number, self: any) =>
            index ===
            self.findIndex((t: any) => t.DESPRESTAZIONE === item.DESPRESTAZIONE)
        )
      );
    } catch (error) {
      console.error("Error fetching prestazioni:", error);
    }
  }

  async function requestDottoriMEDICIPRE() {
    if (doctorsController) {
      doctorsController.abort();
    }
    doctorsController = new AbortController();

    try {
      const data = await doctor(
        {
          tipoAgenda: "",
          listino: "",
          specialita: watchSpecialita?.SPECIALITA ?? "",
          prestazione: watchPrestazione?.PRESTAZIONE ?? "",
          medico: "",
        },
        doctorsController.signal
      );
      const doctorsList = data.data.dati;
      console.log({ doctorsList });
      setDottoriMEDICIPRE(doctorsList);
    } catch (error) {
      console.error("Error fetching dottori:", error);
    }
  }

  // recupero per valorizzare correttamente i campi indicati parametrizzabili
  useEffect(() => {
    requestDottoriMEDICIPRE();
    requestPerformancePRESTAZIONI();
    requestSpecialitiesListSPECIALITA();
  }, [watchSpecialita, watchPrestazione, watchMedico]);

  useEffect(() => {
    const allSedute = dataTerapie?.sedute?.[0]?.seduta ?? [];

    const sedutaColonne = allSedute.find((s: any) => s.idRecord === "");

    const colonne = sedutaColonne?.dati?.[0]?.colonna ?? [];

    context?.setColonne(colonne);

    const recordRows = allSedute.filter((s: any) => s.idRecord !== "");
    context?.setRecords(recordRows);
  }, [dataTerapie]);

  const onSubmitFormCheckedServices = async (data: FormCheckedServices) => {
    await requestCheckedServices(data);
  };

  const requestCheckedServices = async (data: any) => {
    context?.setLoadingDataSpunte(true);
    try {
      const payload: any = {
        aziendaPrenotazione: "MEDITEL",
        funzione: "C",
        numPren: "0",
        descrPaziente: "",
        codSpecia: "",
        codAnapre: "",
        codMedint: "",
        dataDa: watchDataDa,
        dataA: watchDataA,
      };
      const response: any = await spuntaTerapie(payload);

      console.log("Risposta dal server:", response);

      setDataTerapie(response.data);

      // if (response.data[0].esito === "OK") {
      //   setSeverity("success");
      // } else {
      //   setSeverity("error");
      // }
      // setMessage(response.data[0].messaggio);
    } catch (err) {
      console.error("Errore fetch datiPacada:", err);
    } finally {
      context?.setLoadingDataSpunte(false);
      // setShowAllert(true);
    }
  };

  return (
    <form
      onSubmit={context?.methodsFormCheckedServices.handleSubmit(
        onSubmitFormCheckedServices
      )}
    >
      <Grid container spacing={2}>
        {/* Riga uno */}
        <Grid item xs={6}>
          <RHFTextField
            control={context?.methodsFormCheckedServices.control}
            name="numPrenotazione"
            label="Num. Prenotazione"
            placeholder="Numero Prenotazione"
            fullWidth
            disabled={context?.loadingDataSpunte !== null}
          />
        </Grid>
        <Grid item xs={6}>
          <RHFCheckbox
            control={context?.methodsFormCheckedServices.control}
            name={"spunta"}
            label="Seleziona solo da spuntare"
            disabled={context?.loadingDataSpunte !== null}
          />
        </Grid>
        {/* Riga due */}
        <Grid item xs={6}>
          <RHFTextField
            control={context?.methodsFormCheckedServices.control}
            name="paziente"
            label="Paziente"
            placeholder="Cognome nome o Codice Fiscale"
            fullWidth
            disabled={context?.loadingDataSpunte !== null}
          />
        </Grid>
        <Grid item xs={6}>
          <RHFAutocomplete
            control={context?.methodsFormCheckedServices.control}
            name="specialita"
            label="Specialità"
            fullWidth
            size="small"
            options={specialitiesSPECIALITA ?? []}
            getOptionLabel={(option) => option.DESCRIZIONE || ""}
            isOptionEqualToValue={(option, value) =>
              option.SPECIALITA === value.SPECIALITA
            }
            disabled={context?.loadingDataSpunte !== null}
          />
        </Grid>
        {/* Riga tre */}
        <Grid item xs={6}>
          <RHFAutocomplete
            control={context?.methodsFormCheckedServices.control}
            name="prestazione"
            label="Prestazione"
            fullWidth
            size="small"
            options={performancePRESTAZIONI ?? []}
            getOptionLabel={(option) => option.DESCRIZIONE || ""}
            isOptionEqualToValue={(option, value) =>
              option.PRESTAZIONE === value.PRESTAZIONE
            }
            disabled={context?.loadingDataSpunte !== null}
          />
        </Grid>
        <Grid item xs={6}>
          <RHFAutocomplete
            control={context?.methodsFormCheckedServices.control}
            name="medico"
            label="Medico/Risorsa"
            fullWidth
            size="small"
            options={dottoriMEDICIPRE ?? []}
            getOptionLabel={(option: any) => option.CODDESCR || ""}
            isOptionEqualToValue={(option: any, value: any) =>
              option.DESCRIZIONE === value.DESCRIZIONE
            }
            disabled={context?.loadingDataSpunte !== null}
          />
        </Grid>
        {/* Riga quattro */}
        <Grid item xs={6}>
          <RHFDateTimePicker
            name="dallaData"
            control={context?.methodsFormCheckedServices.control}
            dateOnly
            label="Dalla data"
            size="small"
            fullWidth
            disabled={context?.loadingDataSpunte !== null}
          />
        </Grid>
        <Grid item xs={6}>
          <RHFDateTimePicker
            name="allaData"
            control={context?.methodsFormCheckedServices.control}
            dateOnly
            label="Alla data"
            size="small"
            fullWidth
            disabled={context?.loadingDataSpunte !== null}
          />
        </Grid>
        {/* Riga cinque */}
        <Grid item xs={6}>
          <RHFDateTimePicker
            name="periodoDiCompetenza"
            control={context?.methodsFormCheckedServices.control}
            dateOnly
            label="Periodo di competenza"
            size="small"
            fullWidth
            disabled={context?.loadingDataSpunte !== null}
          />
        </Grid>
        <Grid item xs={6}>
          <Button
            variant={"outlinedCustom"}
            type="submit"
            disabled={context?.loadingDataSpunte !== null}
          >
            Seleziona Prestazioni Nel Periodo
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default MainForm;
